import "./App.css";
import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Main from "./Component/Main";
import Terms from "./Component/common/Terms";
import Privacy from "./Component/common/Privacy";
import Legal from "./Component/common/Legal";
import Details from "./Component/Details";
import Checkout from "./Component/CheckOut";
import PaySuccess from "./Component/SuccessPay";
import PayFailure from "./Component/FailedPay";
import Accessibility from "./Component/common/Accessibility";
import AllDonations from "./Component/AllDonations";
import { BASE_URL } from "./constans/ApiEndpointConstants";
import queryString from "query-string";
import LocalStorageUtil from "./utils/localStorageUtil";
import * as GetPixelAPI from "./apis/GetPixelAPI";
import ReactPixel from "react-facebook-pixel";

function App() {
  useEffect(() => {
    const url = BASE_URL;
    const strippedUrl = url.replace(/^https?:\/\//, "");

    const location = window.location.href;
    const result = location.substring(location.indexOf("?"));
    const arr = queryString.parse(result);
    let ad = arr.ad;
    if (!ad || ad.trim() === "") {
      const cachedAd = LocalStorageUtil.getAd();
      if (cachedAd && cachedAd.trim() !== "") {
        ad = cachedAd;
      } else {
        ad = "donation";
      }
    }
    LocalStorageUtil.saveAd(ad);

    GetPixelAPI.getpixel(strippedUrl).then((res) => {
      const data = res.data.data;

      console.log(data);

      if (data && data.pixel) {
        const pixelId = data.pixel;

        // 使用 react-facebook-pixel 初始化
        ReactPixel.init(
          pixelId,
          {},
          {
            debug: true,
            autoConfig: false, // 禁用自动配置
          }
        );
        ReactPixel.pageView();

        // 存储 Pixel 相关数据
        // localStorage.setItem("tgid", data.tgid?.toString() || null);
        // localStorage.setItem("fbqToken", data.fbqToken?.toString());
        // localStorage.setItem("pixel", data.pixel?.toString() || null);
        // localStorage.setItem("stusername", data.stusername?.toString() || null);
        LocalStorageUtil.saveTgid(data.tgid);
        LocalStorageUtil.savePixel(data.pixel);
        LocalStorageUtil.saveFbqToken(data.fbqToken);
        LocalStorageUtil.saveStUsername(data.stusername);
        LocalStorageUtil.saveGroupId(data.groupid);
      }
    });
  }, []);
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/legal" element={<Legal />} />
        <Route path="/donationDetails/:name_id" element={<Details />} />
        <Route path="/donations" element={<AllDonations />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/paysuccess" element={<PaySuccess />} />
        <Route path="/payfial" element={<PayFailure />} />
        <Route path="/accessibility" element={<Accessibility />} />
      </Routes>
    </Router>
  );
}

export default App;
